import InputBirthBS from './InputBirthBS.jsx';

export default InputBirthBS;